import { connect } from 'react-redux';

import { isRating } from 'src/store/hotelRating/selectors';
import {
  getHotelReviewsLink,
  getIsShowMoreReviews,
  getIsReviewsUpgrading,
  getReviews,
  getReviewsTotal,
  getHasReviewsSection,
  getIsNewLoading,
  getSorting,
  getFlattenFilters,
  getErrorResult,
} from 'src/store/reviews/selectors';
import {
  changeFilterStatus,
  retryDownloadAction,
  setSorting,
  showMoreReviews,
} from 'src/store/reviews/slice';
import { getLinkedHotels } from 'src/routes/Hotel/store/hotel';
import { getIsWhitelabel } from '../../../store/selectors/view';

import ReviewsMobile from './ReviewsMobile';
import { getSearchParamsForUrl } from '../../../store/selectors/searchParams';

const mapStateToProps = (state) => ({
  isRatingExists: isRating(state),
  linkedHotels: getLinkedHotels(state),
  hasReviewsSection: getHasReviewsSection(state),
  searchParams: getSearchParamsForUrl(state),
  isWhitelabel: getIsWhitelabel(state),
  totalReviews: getReviewsTotal(state),
  isShowMoreReviews: getIsShowMoreReviews(state),
  hotelReviewsLink: getHotelReviewsLink(state),
  isFetching: getIsReviewsUpgrading(state),
  items: getReviews(state),
  isLoadingNew: getIsNewLoading(state),
  isErrorResult: getErrorResult(state),
  sorting: getSorting(state),
  filters: getFlattenFilters(state),
});

const mapDispatchToProps = {
  showMore: showMoreReviews,
  onChangeSorting: setSorting,
  onChangeFilters: changeFilterStatus,
  onClickRetry: retryDownloadAction,
};

export default connect(mapStateToProps, mapDispatchToProps)(ReviewsMobile);
